/* eslint-disable */ 
jQuery(($) => {

  $.slidebars();

  if ($('#blog-categories-select').length) {
    $('#blog-categories-select').change(function() {
      window.location.href = '/category/' + $(this).val();
    });
  }
  if ($('#blog-tags-select').length) {
    $('#blog-tags-select').change(function() {
      window.location.href = '/tag/' + $(this).val();
    });
  }

  $('.tlc-image-content').attr({ 'data-aos':'fade-up', 'data-aos-duration': '1000' } );

  $('.slide-nav-btn[data-slide]').click(function(e) {
    e.preventDefault();
    var slideno = $(this).data('slide');
    $(this).parent().parent().parent().siblings('.row-slider').slick('slickGoTo', slideno - 1);
    $(this).addClass('active');
    $(this).parent().siblings().children('button').removeClass('active');
  });

  $('.row-slider').slick({
    infinite:true,
    slidesToShow: 1,
    slidesToScroll: 1,   
    prevArrow:'<img class="slick-prev" src="/wp-content/themes/tourlabs-rezgo/assets/img/icon/icon-slider-arrow.png">',
    nextArrow:'<img class="slick-next" src="/wp-content/themes/tourlabs-rezgo/assets/img/icon/icon-slider-arrow.png">',
  });

  $('.row-slider').on('afterChange', function(event, slick, currentSlide){
    $(this).siblings('.row-slider-nav').find('.slide-nav-btn').removeClass('active');
    $(this).siblings('.row-slider-nav').find(`.slide-nav-btn[data-slide="${currentSlide + 1}"]`).addClass('active');
  });
        
  $('.blog-slider-custom').slick({
    infinite:true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows:false,
    
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }

    }, {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },  {
      breakpoint: 520,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }]
  });

  $('.row-standard-slider').slick({
    infinite:true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow:'<img class="slick-prev" src="/wp-content/themes/tourlabs-rezgo/assets/img/icon/icon-arrow-left-green.png">',
    nextArrow:'<img class="slick-next" src="/wp-content/themes/tourlabs-rezgo/assets/img/icon/icon-arrow-right-green.png">',
      
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }

    }, {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },  {
      breakpoint: 520,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows:false,
        dots:true
      }
    }]
  });


  $('.header-nav > li.menu-item-has-children').hover(function() {
    if (!$(this).find('.sub-menu').first().is(':visible')) $(this).find('.sub-menu').first().slideDown();
  }, function() {
    if ($(this).find('.sub-menu').first().is(':visible')) $(this).find('.sub-menu').first().slideUp();
  });

  $('.header-nav > li.menu-item-has-children .sub-menu li.menu-item-has-children').click(function(e) {
    if ($(e.target).parent().hasClass('menu-item-has-children')) {
      e.preventDefault();
      if ($(this).find('.sub-menu').is(':visible')) {
        $(this).find('.sub-menu').stop().slideUp();
        $(this).removeClass('is-active');
      } else {
        $(this).find('.sub-menu').stop().slideDown();
        $(this).addClass('is-active');
      }
    }
  });

  $('.header-nav > li.menu-item-has-children .sub-menu li.current-menu-parent').addClass('is-active');

  const StickyHeader = () => {
    var scroll = $(window).scrollTop();
    if (scroll > 35) {
      $('.header').addClass('sticky');
    } else {
      $('.header').removeClass('sticky');
    }
  };

  StickyHeader();
  $(window).scroll(function (event) {
    StickyHeader();
  });

  $('.tab-toggle-btn').click(function(){
    if($(this).text() === 'hide'){
      $(this).parent().parent().siblings('.tlc-tab-content').slideUp();
      $(this).text('read');
      $(this).removeClass('show-content');
    }else{
      $(this).parent().parent().siblings('.tlc-tab-content').slideDown();
      $(this).text('hide');
  
      $(this).addClass('show-content');
    }

  })

  if($('.mailing-list').length > 0){
    const targetOffset = $('.mailing-list').offset().top - 200;
    $(window).scroll(()=>{
    
      if ($(window).scrollTop() > targetOffset ) {   
        
        $('.large-cloud').css({'transform':'translateX(0)'});
        $('.small-cloud').css({'transform':'translateX(0)'});
        $('.gear-bg').css({'opacity':1});
      } else {
        $('.large-cloud').css({'transform':'translateX(-100%)'});
        $('.small-cloud').css({'transform':'translateX(-250%)'});
        $('.gear-bg').css({'opacity':0});
     
      }
    });
  }

  $('.with-arrow').click(function(){
    if($(this).hasClass('hide-content')){
      $(this).removeClass('hide-content');
      $(this).siblings('.toggle-content').slideDown();
    }else{
      $(this).addClass('hide-content');
      $(this).siblings('.toggle-content').slideUp();
    }
  });

  $('.close-notification').click(function(){
    $(this).parent().slideUp();
    $('body').addClass('notification-close');

    $.ajax({
      type: 'post',
      dataType: 'json',
      url: ajaxurl,
      data: { action: 'tl_notification_banner', tl_action: 'hide_notification_banner' }
    }).done(function(msg) {
      //console.log(msg);
    });
  });

  $('.counter').mouseover(function(){
    var $this = $(this);
    $({ Counter: 0 }).animate({ Counter: $this.text() }, {
      duration: 2000,
      easing: 'swing',
      step: function () {
        $this.text(this.Counter.toFixed(1) + "%");
      }
    });
  });

  if($(window).width() < 600){
    $('.mailing-list-form form').css({width: $(window).width() +"px", height: $(window).width() +"px"});
  }
  $(window).resize(function(){
    if($(window).width() < 600){
      $('.mailing-list-form form').css({width: $(window).width() +"px", height: $(window).width() +"px"});
    }
  });
  
  $('.sb-slidebar .menu-item-has-children > a').click(function(e){
    e.preventDefault();
    $(this).parent().find('> .sub-menu').slideToggle();
    $(this).toggleClass('menu-item-active');
  });

  $('.toggle-footer-menu').click(function(){
    if($(window).width() < 767){
      $('.footer-nav1').slideToggle();
    }
  });

  $('.blog-select').select2({
    minimumResultsForSearch: Infinity,
  }); 
  
  AOS.init();
});
